export const tenantProfileKeys = {
  all: ['tenant-profile'] as const,
  me: (): readonly unknown[] => [...tenantProfileKeys.all, 'me'] as const,
};
